import React, { useState, useEffect, useCallback } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import { Droplets } from 'lucide-react';

export const ProductGallery = ({ product }) => {
  const images = product.images?.length ? product.images : (product.image_url ? [product.image_url] : []);
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: images.length > 1 });
  const [selected, setSelected] = useState(0);

  const onSelect = useCallback(() => emblaApi && setSelected(emblaApi.selectedScrollSnap()), [emblaApi]);

  useEffect(() => {
    if (!emblaApi) return;
    emblaApi.on('select', onSelect);
    return () => emblaApi.off('select', onSelect);
  }, [emblaApi, onSelect]);

  if (!images.length) {
    return (
      <div className="w-56 h-56 bg-white rounded-2xl shadow-xl flex items-center justify-center mx-auto">
        <Droplets className="w-20 h-20 text-sonangol-red" />
      </div>
    );
  }

  return (
    <div data-testid="product-gallery">
      <div className="w-64 h-64 sm:w-72 sm:h-72 mx-auto bg-white rounded-2xl shadow-xl overflow-hidden" ref={emblaRef}>
        <div className="flex h-full touch-pan-y">
          {images.map((url, i) => (
            <div key={url} className="flex-[0_0_100%] min-w-0 h-full" data-testid={`product-gallery-slide-${i}`}>
              <img src={url} alt={`${product.name} ${i + 1}`} className="w-full h-full object-cover" draggable={false} />
            </div>
          ))}
        </div>
      </div>
      {images.length > 1 && (
        <div className="flex justify-center gap-1 mt-4">
          {images.map((url, i) => (
            <button key={url} onClick={() => emblaApi?.scrollTo(i)} aria-label={`Imagem ${i + 1}`}
              className="px-2 py-4" data-testid={`product-gallery-dot-${i}`}>
              <span className={`block h-2 rounded-full transition-all duration-300 ${i === selected ? 'w-6 bg-sonangol-red' : 'w-2 bg-zinc-400'}`} />
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default ProductGallery;
